import { AddressJSON } from "_shared/addresses/address-schema";
import EntityOfficerInvitation from "legal-entities/invitations/officer-invitations/entity-officer-invitation";

export default class InviteEntityOfficerAPIRequest {
  public email: string;
  public firstName?: string;
  public lastName?: string;
  public entityName: string;
  public message?: string;
  public entityLocation?: AddressJSON;
  public title?: string;

  public constructor(invitation: EntityOfficerInvitation) {
    if (!invitation.registrationInfo) throw new Error("Registration info is required");
    if (!invitation.entityName) throw new Error("Entity name is required");
    if (!invitation.registrationInfo.email) throw new Error("Email address is required");
    if (!invitation.registrationInfo.name) throw new Error("Name is required");

    this.email = invitation.registrationInfo.email.value;
    this.firstName = invitation.registrationInfo.name.firstName;
    this.lastName = invitation.registrationInfo.name.lastName;
    this.entityName = invitation.entityName.value;
    this.message = invitation.message?.value;
    this.entityLocation = invitation.entityLocation?.toJSON();
    this.title = invitation.title?.value;
  }
}
